import basicAxios from "axios";
import axios from "./axios";
import { BASE_URL } from "@src/utils";

export const uploadImage = (data: any) => {
  return axios.post<{ data: string; result: number }>(`${BASE_URL}/web/v1/common/upload`, data);
};

// 선언 위치가 common이 맞을까???
export interface IResFaq {
  title: string;
  faqList: IResFaqItem[];
}
export interface IResFaqItem {
  categoryId: number;
  question: string;
  answer: string;
  button: {
    link: string;
    text: string;
  } | null;
}
export const getFaqs = () => {
  return axios.get<{ item: IResFaq[] }>(`${BASE_URL}/v4/faq`);
};

// 회원 정보 인터페이스
export interface IMe {
  updated: boolean;
  loggedin: boolean;
  dDay: number;
  me: any;
  bookieUnreadCount: number;
  newPushTsp: string;
}

export const getHomeMe = () => {
  return basicAxios.get<{ item: IMe }>(`${BASE_URL}/v3/home/me`);
};

export const postRefreshToken = async (refreshToken: string) => {
  const data = { refreshToken: refreshToken };
  const accessToken = localStorage.getItem("accessToken");
  const headers = { Authorization: `bearer ${accessToken}` };
  return basicAxios.post<{
    item: { accessToken: string; refreshToken: string };
    result: 0 | 1;
    msg?: string;
  }>(`${BASE_URL}/v3/jwt/refresh?refreshToken=${refreshToken}`, data, { headers });
};
